import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import styles from './AdminUsers.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import PageTable from '../../../Shared/PageTable/PageTable';
import { useAxios } from '../../../../AxiosHandler';

function AdminUsers(props: AdminUsersProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [invitationLink, setInvitationLink] = React.useState<string>("");
    const [invitationCouncilName, setInvitationCouncilName] = React.useState<string>("");

    var testTraits = [
        "EMAIL",
        "FIRSTNAME",
        "LASTNAME",
        "ROLE",
        "MAIN_BREED_NAME",
        "COUNCILS",
    ];

    function createTraitColumn(trait: any) {
        if (trait != undefined) {
            let column: any = {
                label: t("admin.areas.adminusers.table.headers." + trait),
                field: trait,
            };
            
            return column;
        } else {
            return undefined;
        }
    }

    function createColumns() {
        let columns: any[] = [];
        testTraits.forEach((trait: string) => {
            columns.push(createTraitColumn(trait));
        });
        
        return columns;
    }

    function fetchInvitationLink() {
        axios.single({
            method: 'get',
            url: "/api/users/invitationlink/" + auth.selectedBreed,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setInvitationLink(res.data.link);
            setInvitationCouncilName(res.data.councilName);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        fetchInvitationLink();
    }, [auth.selectedBreed]);

    return (
        <div className="users">
            {invitationLink && (
                <div
                    className={styles.invitationlink}
                >
                    <a href={invitationLink} target="_blank" rel="noopener noreferrer">
                        {t("admin.areas.adminusers.invitationlink", { council: invitationCouncilName })}
                    </a>
                </div>
            )}
            <hr/>
            <button className="btn btn-primary" onClick={() => navigate("/createuser", { state: { listSearch: location.search } })}>{t("user.buttons.adduser")}</button>
            <hr/>
            <PageTable
                dataUrl="/api/users/getAllPaged"
                saveFiltersKey={"adminusers.table." + auth.selectedBreed}
                onLineClick={(dataLine: any) => navigate("/user/" + dataLine.ID, {
                    // Ta med hvilken seksjon som er åpen på /admin, så tilbake-knappen
                    // på brukersida treffer den samme.
                    state: { listSearch: location.search },
                })}
                options={{
                    showFields: [
                        ...createColumns(),
                    ],
                    pageSize: 5,
                }}
                selectedTraits={testTraits}
                clickable
                defaultSortDirection="desc"
                defaultSortField="EMAIL"
                hidePagination={false}
                hidePagesize={false}
                hideFilter={false}
            />
        </div>
    );
}

class AdminUsersProps {
    
}

export default AdminUsers;